<script lang="ts">
    import Banner from "./Banner.svelte";
    import NavBar from "./NavBar.svelte";

    import { authenticationStatus } from "../../store/stores.ts";

    let visible:boolean = false;
    let authStatus;

    authenticationStatus.subscribe(value =>
        authStatus = value
    )

    if (authStatus.authenticated) {
        visible = true;
    }

</script>

<header>
    <Banner/>
    {#if visible}
        <NavBar/>
    {/if}
</header>

